import axios from 'axios';

// @todo
export const doRedirectToRegistration = async (router, myFormData) => {
    const { email, name } = myFormData;
    let registration = `https://ocellot.trisbee.com/register?email=${email}`;

    if (name) {
        const parts = name.split(' ');
        const firstName = parts[0];
        const lastName = parts[parts.length - 1];

        if (firstName) {
            registration += `&name=${firstName}`;
        }

        if (lastName) {
            registration += `&lastName=${lastName}`;
        }
    }

    await router.push(registration);
};

/**
 * convert json data to form data for google API
 *
 * @param data
 * @returns {string}
 */
export function encodeData(data) {
    return Object.keys(data)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`)
        .join('&');
}

/**
 * send request to Google Action Script API
 *
 * @param url
 * @param data
 * @param conversionName
 * @returns {{working: boolean, sent: boolean}}
 */
export async function sendGoogleScript(url, data, conversionName) {
    const output = {
        sent: false,
        error: false,
        working: true,
    };

    const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: encodeData(data),
        url,
    };

    try {
        await axios(options);
        output.sent = true;

        if (typeof window !== 'undefined') {
            const dataLayer = window.dataLayer || [];
            dataLayer.push({ lead: conversionName });
        }
    } catch (err) {
        console.error('ContactForm - bad response from Google API!', err);
        output.error = true;
    } finally {
        output.working = false;
    }

    return output;
}